import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, IconButton, TextField, Typography } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { Values } from '../../../../../../values/Values';
import Grid from '@material-ui/core/Grid';
import LockIcon from '@material-ui/icons/Lock';
import Chip from '@material-ui/core/Chip';
import useTheme from '@material-ui/styles/useTheme';
import CancelIcon from '@material-ui/icons/Cancel';
import { autorizarModoAdmin } from '../../../../../../services/AuthService';
import { SidebarNav } from '../index';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Alert from '@material-ui/lab/Alert/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle/AlertTitle';
import moment from 'moment';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1),
    color: Values.cores.branco
  },
  subnome: {
    color: Values.cores.branco
  }
}));

function Profile(props) {
  const {
    className,
    usuario,
    history,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    ...rest
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [modoAnonimo, setModoAnonimo] = useState(false);
  const [
    showDialogConfirmacaoModoAdmin,
    setShowDialogConfirmacaoModoAdmin
  ] = useState(false);
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);

  useEffect(() => {
    const anonimo = JSON.parse(localStorage.getItem('modoAnonimo'));
    setModoAnonimo(anonimo);
  }, []);

  function ativarModoAnonimo() {
    try {
      localStorage.setItem('modoAnonimo', true.toString());
      history.push('/dashboard');
      window.location.reload();
    } catch (e) {
      history.push('/dashboard');
      window.location.reload();
    }
  }

  async function ativarModoAdministrativo() {
    try {
      setShowDialogConfirmacaoModoAdmin(false);
      setLoading(true);
      let autorizacao = await autorizarModoAdmin(senha);
      setLoading(false);
      if (autorizacao.isSuccess) {
        setSenha('');
        setMostrarSenha(false);
        localStorage.setItem('modoAnonimo', false.toString());
        history.push('/dashboard');
        window.location.reload();
      } else {
        setSenha('');
        setMostrarSenha(false);
        setTypeSnack('warning');
        setMessageSnack(autorizacao.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  return (
    <Grid
      container
      spacing={0}
      style={{
        marginTop: 20,
        textAlign: 'center'
      }}>
      <Grid item md={12} xs={12}>
        <Dialog
          open={showDialogConfirmacaoModoAdmin}
          aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Confirmação</DialogTitle>
          <DialogContent>
            <Alert severity="warning" variant="outlined">
              <AlertTitle>Atenção</AlertTitle>
              Tem certeza que deseja sair?
            </Alert>

            <TextField
              id="outlined-adornment-password"
              variant="outlined"
              margin="dense"
              fullWidth
              value={senha}
              type={mostrarSenha ? 'text' : 'password'}
              label="Informe a senha"
              onChange={e => setSenha(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      aria-label="toggle password visibility"
                      onClick={e => setMostrarSenha(!mostrarSenha)}>
                      {mostrarSenha ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              helperText="Informe sua senha"
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={e => setShowDialogConfirmacaoModoAdmin(false)}
              color="primary">
              Cancel
            </Button>
            <Button onClick={e => ativarModoAdministrativo()} color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        style={{
          justifyContent: 'center',
          display: 'flex'
        }}>
        <Avatar
          style={{
            width: 56,
            height: 56
          }}
          onClick={e => setShowDialogConfirmacaoModoAdmin(true)}
          src={usuario && usuario.imagemPerfil && usuario.imagemPerfil.url}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography className={classes.name} variant="h4">
          {usuario && usuario.nomeFantasia}
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography className={classes.name} variant="body2">
          {usuario && usuario.tipoUsuario && usuario.tipoUsuario.descricao}
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography className={classes.subnome} variant="body2">
          {usuario && usuario.email}
        </Typography>
      </Grid>
      {!modoAnonimo && (
        <Grid
          item
          md={12}
          xs={12}
          style={{
            marginTop: 3
          }}>
          <Chip
            size="small"
            label="Modo Administrativo"
            style={{
              backgroundColor: theme.palette.error.main,
              color: 'white'
            }}
            onClick={ativarModoAnonimo}
            onDelete={ativarModoAnonimo}
            icon={<LockIcon style={{ color: 'white' }} />}
            deleteIcon={<CancelIcon style={{ color: 'white' }} />}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default Profile;
